module.exports = __webpack_public_path__ + "static/media/ic_audio_off_small_transparent.f126d80a.svg";